module.exports = __webpack_public_path__ + "static/img/tv3.ebbbcda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/companies/marketmaker/assets/tv3.jpg
// module id = d9j0
// module chunks = 1